<div class="container-jumbotron" [style]="{'background-image': 'url(' + imgPath + ')'}">
    <div class="container h-100 d-flex justify-content-center align-items-center">
        <div class="d-flex flex-wrap flex-column-reverse flex-md-row align-items-center h-100 w-100 m-auto">
            <div class="container-jumbotron__container-text col-12 col-md-6">
                <a *ngIf="block.titolo && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(block.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(block.link_cta.url).queryParams">
                    <h2 class="text-white ls-h2-title" [innerHTML]="block.titolo"></h2>
                </a>
                <a *ngIf="block.titolo && isLinkEsternal" [href]="[block.link_cta.url]">
                    <h2 class="text-white ls-h2-title" [innerHTML]="block.titolo"></h2>
                </a>
                <p *ngIf="block.caption" class="text-white ls-p" [innerHTML]="block.caption"></p>
                <div class="mt-4">
                    <a *ngIf="block.label_cta && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(block.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(block.link_cta.url).queryParams">
                        <button
                            class="container-jumbotron__container-text__button btn btn-default text-uppercase ls-label-medium-semibold"
                            [innerHTML]="block.label_cta.length > 40 ? block.label_cta.substring(0, 40) + '...' : block.label_cta"></button>
                    </a>
                    <a class="btn-primario btn-custom-jumbotron ls-label-medium text-uppercase"
                        *ngIf="block.link_cta && isLinkEsternal" [href]="block.link_cta.url"
                        [innerHTML]="block.label_cta.length > 40 ? block.label_cta.substring(0, 40) + '...' : block.label_cta">
                    </a>
                </div>
            </div>
            <div class="container-jumbotron__container-icon col-12 col-md-6 d-flex justify-content-center align-items-center h-25"
                *ngIf="block.link_a_contenuto_video === 'Sì'">
                <a [href]="block.link_cta.url" target="_blank">
                    <i class="fa-solid fa-circle-play cursor-pointer" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</div>